/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'THE_FACILITY_HAS_PERFORMED_A_RISK_ASSESSMENT_OF_WHERE_HEAT_OR_C',
              'SHIELDS_ARE_IN_PLACE_TO_PROTECT_WORKERS_FROM_RADIANT_HEAT_SOURC',
              'WORKERS_WHO_ARE_EXPOSED_TO_HEAT_RADIATION_ARE_GIVEN_REST_BREAKS',
              'FACILITY_HAS_IMPLEMENTED_BASIC_MEDICAL_SURVEILLANCE_TECHNIQUES_',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_14: valueSchema,
  },
}
